<template>
  <header class="site-header" :class="{ 'site-header--open': mobileOpen || productsOpen }">
    <div class="w1280 site-header__inner">
      <router-link class="brand" to="/" @click="closeMenus">
        <span class="brand__mark"></span>
        <span class="brand__copy">
          <strong>QE</strong>
          <small>Quant Evolution</small>
        </span>
      </router-link>

      <nav class="nav-list" aria-label="主导航">
        <router-link class="nav-list__link" :class="{ 'is-active': isActive('/') }" to="/">
          首页
        </router-link>
        <div class="nav-list__group" @mouseenter="productsOpen = true" @mouseleave="productsOpen = false">
          <button
            class="nav-list__link nav-list__button"
            :class="{ 'is-active': isProductRoute }"
            type="button"
            @click="toggleProducts"
          >
            产品与应用
            <span class="nav-list__caret"></span>
          </button>

          <transition name="fade">
            <div v-show="productsOpen" class="submenu">
              <router-link
                v-for="item in productItems"
                :key="item.to"
                class="submenu__link"
                :to="item.to"
                @click="closeMenus"
              >
                <span class="submenu__index">{{ item.index }}</span>
                <span>
                  <strong>{{ item.label }}</strong>
                  <small>{{ item.note }}</small>
                </span>
              </router-link>
            </div>
          </transition>
        </div>
        <router-link class="nav-list__link" :class="{ 'is-active': isActive('/Service') }" to="/Service">
          服务定价
        </router-link>
        <router-link class="nav-list__link" :class="{ 'is-active': isActive('/Resource') }" to="/Resource">
          资源中心
        </router-link>
        <router-link class="nav-list__link" :class="{ 'is-active': isActive('/about') }" to="/about">
          关于我们
        </router-link>
      </nav>

      <div class="site-header__meta">
        <span class="site-header__label">AIGC Synthetic Data</span>
        <button class="mobile-toggle" type="button" :aria-expanded="mobileOpen" @click="toggleMobile">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </div>

    <transition name="slide-down">
      <div v-if="mobileOpen" class="mobile-panel">
        <div class="w1280 mobile-panel__inner">
          <router-link class="mobile-panel__link" to="/" @click="closeMenus">首页</router-link>
          <button class="mobile-panel__link mobile-panel__button" type="button" @click="mobileProductsOpen = !mobileProductsOpen">
            产品与应用
            <span class="mobile-panel__state">{{ mobileProductsOpen ? '收起' : '展开' }}</span>
          </button>
          <div v-if="mobileProductsOpen" class="mobile-panel__submenu">
            <router-link
              v-for="item in productItems"
              :key="`${item.to}-mobile`"
              class="mobile-panel__sublink"
              :to="item.to"
              @click="closeMenus"
            >
              <span>{{ item.index }}</span>
              {{ item.label }}
            </router-link>
          </div>
          <router-link class="mobile-panel__link" to="/Service" @click="closeMenus">服务定价</router-link>
          <router-link class="mobile-panel__link" to="/Resource" @click="closeMenus">资源中心</router-link>
          <router-link class="mobile-panel__link" to="/about" @click="closeMenus">关于我们</router-link>
        </div>
      </div>
    </transition>
  </header>
</template>

<script>
export default {
  name: 'SiteNavigation',
  data() {
    return {
      mobileOpen: false,
      mobileProductsOpen: false,
      productsOpen: false,
      productItems: [
        { index: '01', label: '合成数据引擎', note: '核心生成与评价能力', to: '/Product?id=8' },
        { index: '02', label: '金融量化应用', note: '面向市场策略与回测', to: '/Product?id=4' },
        { index: '03', label: '风险控制应用', note: '用于风控推演与验证', to: '/Product?id=9' },
        { index: '04', label: '软件测试应用', note: '业务测试与覆盖生成', to: '/Product?id=7' },
        { index: '05', label: '智慧医疗应用', note: '医疗场景数据模拟', to: '/Product?id=6' },
        { index: '06', label: '社会研究应用', note: '人口与社会问题建模', to: '/Product?id=3' },
      ],
    }
  },
  computed: {
    isProductRoute() {
      return this.$route.path.toLowerCase() === '/product'
    },
  },
  watch: {
    $route() {
      this.closeMenus()
    },
  },
  methods: {
    isActive(path) {
      return this.$route.path.toLowerCase() === path.toLowerCase()
    },
    toggleMobile() {
      this.mobileOpen = !this.mobileOpen
      if (!this.mobileOpen) {
        this.mobileProductsOpen = false
      }
    },
    toggleProducts() {
      this.productsOpen = !this.productsOpen
    },
    closeMenus() {
      this.mobileOpen = false
      this.mobileProductsOpen = false
      this.productsOpen = false
    },
  },
}
</script>

<style lang="less" scoped>
.site-header {
  position: fixed;
  inset: 0 0 auto;
  z-index: 200;
  background: rgba(247, 247, 244, 0.92);
  border-bottom: 1px solid rgba(17, 17, 17, 0.08);
  backdrop-filter: blur(16px);
}

.site-header--open {
  border-bottom-color: rgba(17, 17, 17, 0.14);
}

.site-header__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: var(--header-height);
  gap: 24px;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  color: var(--text-strong);
}

.brand__mark {
  width: 12px;
  height: 12px;
  background: var(--accent);
  border-radius: 2px;
  box-shadow: 18px 0 0 rgba(17, 17, 17, 0.12);
}

.brand__copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.brand__copy strong {
  font-size: 15px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.brand__copy small {
  color: var(--text-muted);
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.nav-list {
  display: flex;
  align-items: center;
  gap: 28px;
  margin-left: auto;
}

.nav-list__link,
.nav-list__button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
  border: 0;
  background: transparent;
  color: var(--text-base);
  font-size: 13px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  transition: color 0.2s ease;
}

.nav-list__link:hover,
.nav-list__button:hover,
.nav-list__link.is-active,
.nav-list__button.is-active {
  color: var(--text-strong);
}

.nav-list__group {
  position: relative;
}

.nav-list__caret {
  width: 6px;
  height: 6px;
  border-right: 1px solid currentColor;
  border-bottom: 1px solid currentColor;
  transform: rotate(45deg) translateY(-1px);
}

.submenu {
  position: absolute;
  top: calc(100% + 16px);
  left: 0;
  display: grid;
  gap: 10px;
  min-width: 320px;
  padding: 18px;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid var(--border);
  border-radius: 22px;
  box-shadow: var(--shadow-soft);
}

.submenu__link {
  display: grid;
  grid-template-columns: 36px 1fr;
  gap: 14px;
  padding: 12px 14px;
  border-radius: 16px;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.submenu__link:hover {
  background: var(--surface-soft);
  transform: translateX(2px);
}

.submenu__index {
  color: var(--accent);
  font-size: 11px;
  letter-spacing: 0.18em;
}

.submenu__link strong {
  display: block;
  color: var(--text-strong);
  font-size: 14px;
  font-weight: 600;
}

.submenu__link small {
  display: block;
  margin-top: 4px;
  color: var(--text-muted);
  font-size: 12px;
}

.site-header__meta {
  display: flex;
  align-items: center;
  gap: 16px;
}

.site-header__label {
  color: var(--text-muted);
  font-size: 11px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
}

.mobile-toggle {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 42px;
  height: 42px;
  padding: 0;
  border: 1px solid var(--border);
  border-radius: 14px;
  background: var(--surface);
}

.mobile-toggle span {
  width: 18px;
  height: 1px;
  margin: 0 auto;
  background: var(--text-strong);
}

.mobile-panel {
  border-top: 1px solid rgba(17, 17, 17, 0.08);
  background: rgba(255, 255, 255, 0.98);
}

.mobile-panel__inner {
  display: grid;
  gap: 8px;
  padding: 10px 0 20px;
}

.mobile-panel__link,
.mobile-panel__button,
.mobile-panel__sublink {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 16px 0;
  border: 0;
  border-bottom: 1px solid rgba(17, 17, 17, 0.08);
  background: transparent;
  color: var(--text-strong);
  font-size: 14px;
}

.mobile-panel__state,
.mobile-panel__sublink span {
  color: var(--accent);
  font-size: 11px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.mobile-panel__submenu {
  display: grid;
  gap: 4px;
  padding: 0 0 10px;
}

.mobile-panel__sublink {
  padding: 12px 0;
  color: var(--text-base);
}

.fade-enter-active,
.fade-leave-active,
.slide-down-enter-active,
.slide-down-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.fade-enter-from,
.fade-leave-to,
.slide-down-enter-from,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

@media (max-width: 960px) {
  .nav-list,
  .site-header__label {
    display: none;
  }

  .mobile-toggle {
    display: inline-flex;
  }
}
</style>
